<div class="modal-container">
  <h2 class="modal-header">We just updated some things in Lineup. Please reload your browser to continue.</h2>
  <p *ngIf="hasSubheader" class="modal-subheader">{{ subheader }}</p>
  <div class="modal-action-container" fxLayout="column" fxLayoutAlign="space-around center">
    <button mat-raised-button color="primary" (click)="reloadBrowser()">Reload browser</button>
    <p>
      We'll automatically reload your browser in <span>{{ counter }}</span> seconds.
    </p>
  </div>
</div>
